import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  addCreditCardRequest: ['totalValueOrder'],
  addCreditCardSuccess: ['data'],
  addCreditCardError: ['error'],

  updateCreditCardRequest: ['data'],
  updateCreditCardSuccess: ['data'],
  updateCreditCardError: ['error'],

  removeCreditCardRequest: [],
  removeCreditCardSuccess: ['data'],
  removeCreditCardError: ['error'],

  selectCreditCardRequest: ['sequencia'],
  selectCreditCardSuccess: ['data'],
  selectCreditCardError: ['data'],

  validateCreditCardRequest: ['data'],
  validateCreditCardSuccess: ['data'],
  validateCreditCardError: ['error'],

  getBalancePendingRequest: [],
  getBalancePendingSuccess: ['data'],
  getBalancePendingError: ['error'],

  getInstallmentRequest: ['value', 'isTotem'],
  getInstallmentSuccess: ['data'],
  getInstallmentError: ['error'],

  clearCreditCardsRequest: ['totalValueOrder'],
});

const INITIAL_STATE = Immutable({
  isLoading: false,
  error: {},
  creditCards: {},
  creditCard: {},
  totalValueOrder: 0,
  totalPending: 0,
});

const addCreditCardRequest = (state = INITIAL_STATE, { totalValueOrder }) =>
  state.set('totalValueOrder', totalValueOrder);

const addCreditCardSuccess = (state = INITIAL_STATE, { data: { totalPending, creditCard } }) =>
  state
    .set('totalPending', totalPending)
    .set('creditCard', creditCard)
    .setIn(['creditCards', creditCard.sequencia], creditCard);
const addCreditCardError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const updateCreditCardSuccess = (state = INITIAL_STATE, { data: { totalPending, creditCards, creditCard } }) =>
  state
    .set('isLoading', false)
    .set('totalPending', totalPending)
    .set('creditCard', creditCard)
    .set('creditCards', creditCards)
    .setIn(['creditCards', state.getIn(['creditCard', 'sequencia'])], creditCard);
const updateCreditCardError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const removeCreditCardSuccess = (state = INITIAL_STATE, { data: { totalPending, creditCards } }) =>
  state.set('totalPending', totalPending).set('creditCard', creditCards['1']).set('creditCards', creditCards);

const removeCreditCardError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const selectCreditCardRequest = (state = INITIAL_STATE, { sequencia }) =>
  state.set('creditCard', state.getIn(['creditCards', sequencia]));

const validateCreditCardRequest = (state = INITIAL_STATE) => state.setIn(['creditCard', 'isLoading'], true);

const validateCreditCardSuccess = (state = INITIAL_STATE, { data }) =>
  state.set('creditCard', data).setIn(['creditCards', data.sequencia], data);

const validateCreditCardError = (state = INITIAL_STATE, { error }) =>
  state.merge({ error, creditCard: { isLoading: false } });

const clearCreditCardsRequest = (state = INITIAL_STATE, { totalValueOrder }) =>
  state.merge({ creditCards: {}, creditCard: {}, totalValueOrder });

const getBalancePendingSuccess = (state = INITIAL_STATE, { data }) =>
  state.set('creditCard', data).setIn(['creditCards', data.sequencia], data);

const getBalancePendingError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const getInstallmentError = (state = INITIAL_STATE, { error }) => state.set('error', error);

export default createReducer(INITIAL_STATE, {
  [Types.ADD_CREDIT_CARD_REQUEST]: addCreditCardRequest,
  [Types.ADD_CREDIT_CARD_SUCCESS]: addCreditCardSuccess,
  [Types.ADD_CREDIT_CARD_ERROR]: addCreditCardError,

  [Types.UPDATE_CREDIT_CARD_SUCCESS]: updateCreditCardSuccess,
  [Types.UPDATE_CREDIT_CARD_ERROR]: updateCreditCardError,

  [Types.REMOVE_CREDIT_CARD_SUCCESS]: removeCreditCardSuccess,
  [Types.REMOVE_CREDIT_CARD_ERROR]: removeCreditCardError,

  [Types.GET_BALANCE_PENDING_SUCCESS]: getBalancePendingSuccess,
  [Types.GET_BALANCE_PENDING_ERROR]: getBalancePendingError,

  [Types.SELECT_CREDIT_CARD_REQUEST]: selectCreditCardRequest,

  [Types.VALIDATE_CREDIT_CARD_REQUEST]: validateCreditCardRequest,
  [Types.VALIDATE_CREDIT_CARD_SUCCESS]: validateCreditCardSuccess,
  [Types.VALIDATE_CREDIT_CARD_ERROR]: validateCreditCardError,

  [Types.CLEAR_CREDIT_CARDS_REQUEST]: clearCreditCardsRequest,

  [Types.GET_INSTALLMENT_ERROR]: getInstallmentError,
});
